
<script lang="ts">
import { onMount } from "svelte";

	import { Router, Route } from "svelte-navigator";
	import { Styles } from "sveltestrap";
	import RouteGuard from "./components/RouteGuard.svelte";
	// import { ROL_SUPERADMIN } from "./evironment";
	import Index from "./Pages/index.svelte";
	import Login from "./Pages/login.svelte";
import Results from "./Pages/results.svelte";

	onMount(updateCssVars);

	function updateCssVars(): void {
		window.document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
	}

</script>

<svelte:window on:resize={updateCssVars} />

<Styles />

<Router primary={false}>

	<Route path="/v/:alias">
		<Login />
	</Route>

	<Route path="/r/:qwerty">
		<Login />
	</Route>

	<Route path="/login">
		<Login />
	</Route>

	<Route path="/">
		<RouteGuard>
			<Index />
		</RouteGuard>
	</Route>
	<Route path="/qwerty">
		<RouteGuard>
			<Results />
		</RouteGuard>
	</Route>
	<Route path="*">
		NotFound 
	</Route>
</Router>

